import { useTranslation } from "react-i18next";
import { SettingsSection } from "./settingSection.component";
import {
  DropdownOption,
  DropdownWithLabel,
} from "web-apps/company/components/general/dropDownWithLabel/dropdownWithLabel.component";

export const CompanyTimeZoneSetting: React.FC<{
  value: string;
  onChange: (v: string) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const timeZoneOptions: DropdownOption[] = [
    { label: "Europe/Stockholm", value: "Europe/Stockholm" },
  ];

  return (
    <SettingsSection
      title={t("System.CompanyTimeZone")}
      info={t("System.CompanyTimeZoneInfo")}
    >
      <DropdownWithLabel
        label={t("System.CompanyTimeZone")}
        options={timeZoneOptions}
        value={value}
        onChange={onChange}
        required
        disabled
      />
    </SettingsSection>
  );
};
